import { useCallback } from "react";
import { SearchDialogStatesType } from "../states/dialogs";

export const useSearchPricingDialogHandlers = (
  dialogStates: SearchDialogStatesType
) => {
  const onPricingDialogClose = useCallback(() => {
    dialogStates.setShowPricingDialog(false);
  }, [dialogStates]);

  const onPricingDialogMouseDown = useCallback(() => {}, []);

  const onOkButtonClick = useCallback(() => {}, []);

  return {
    onPricingDialogClose,
    onPricingDialogMouseDown,

    onOkButtonClick
  } as const;
};

export type SearchPricingDialogHandlersType = ReturnType<
  typeof useSearchPricingDialogHandlers
>;
